import React, { useEffect, useRef, useState } from "react";
import { fetchMeetupspagelist } from "../services/Meetupspagelist";
import { API_BASE } from "../api/apiConfig";

const UpcomingMeetups = () => {
  const [meetups, setMeetups] = useState([]);
  const [activeCountry, setActiveCountry] = useState("All");
  const [activeCity, setActiveCity] = useState("All");
  const sliderRef = useRef(null);

  useEffect(() => {
    const loadData = async () => {
      const res = await fetchMeetupspagelist();
      if (res?.status && Array.isArray(res.data)) {
        setMeetups(res.data);
      }
    };
    loadData();
  }, []);


   /* ================= HELPERS ================= */
  const parseCategories = (category) => {
    if (!category) return [];
    try {
      const parsed = JSON.parse(category);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  /* ================= FILTER DATA ================= */

  const countries = [
    "All",
    ...new Set(meetups.map((m) => m.country).filter(Boolean)),
  ];

  const cities = [
    "All",
    ...new Set(
      meetups
        .filter(
          (m) => activeCountry === "All" || m.country === activeCountry
        )
        .map((m) => m.city)
        .filter(Boolean)
    ),
  ];

  const filteredMeetups = meetups.filter((m) => {
    if (activeCountry !== "All" && m.country !== activeCountry) return false;
    if (activeCity !== "All" && m.city !== activeCity) return false;
    return true;
  });

  /* ================= SLIDER SCROLL ================= */

  const scrollSlider = (dir) => {
    if (!sliderRef.current) return;
    sliderRef.current.scrollBy({
      left: dir === "next" ? 350 : -350,
      behavior: "smooth",
    });
  };

  return (
    <section className="relative w-full bg-white py-10 md:py-14 text-slate-800 meet-section">
      <div className="absolute left-0 top-0 h-64 w-64 rounded-full bg-primary/5 blur-3xl"></div>
      <div className="absolute bottom-0 right-0 h-64 w-64 rounded-full bg-primary/5 blur-3xl"></div>

      <div className="container relative z-10 mx-auto px-4 sm:px-5 md:px-6">

        {/* HEADER */}
        <div className="mb-6 md:mb-8 flex flex-col md:flex-row justify-between gap-3">
          <div>
            <div className="mb-2 inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-2.5 py-1 text-sm font-medium text-primary">
              <span className="mr-1.5 h-1.5 w-1.5 rounded-full bg-primary animate-pulse-soft"></span>
              Connect In Person
            </div>
            <h2 className="text-xl md:text-2xl font-bold">
              Upcoming <span className="text-gradient">Meetups</span>
            </h2>
            <p className="max-w-[700px] text-sm md:text-base text-slate-700">
              Join fellow travelers at these community-organized events across India. From city walks to cultural experiences, there's something for everyone.
            </p>
          </div>
          <div class="flex items-center gap-2 text-sm md:text-base font-medium mt-3 md:mt-0">
            <button class="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md px-3 border-primary/30 bg-transparent text-primary hover:bg-primary/10 btn-pulse">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-filter mr-1.5 h-4 w-4"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>Filter Events</button><button class="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-9 rounded-md px-3 border-primary/30 bg-transparent text-primary hover:bg-primary/10 btn-pulse"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search mr-1.5 h-4 w-4"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg>Search</button></div>
        </div>

        {/* ================= COUNTRY TABS ================= */}
        {/*<div className="mb-4 overflow-x-auto">
          <div className="flex gap-2 min-w-max">
            {countries.map((country) => (
              <button
                key={country}
                onClick={() => {
                  setActiveCountry(country);
                  setActiveCity("All");
                }}
                className={`px-4 py-1.5 rounded-full text-sm transition-all ${
                  activeCountry === country
                    ? "bg-primary text-white"
                    : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}
              >
                {country}
              </button>
            ))}
          </div>
        </div>*/}

        {/* ================= CITY TABS ================= */}
        <div className="mb-5 overflow-x-auto">
          <div className="flex gap-2 min-w-max">
            {cities.map((city) => (
              <button
                key={city}
                onClick={() => setActiveCity(city)}
                className={`px-3 py-1.5 rounded-full text-sm transition-all ${
                  activeCity === city
                    ? "bg-primary text-white"
                    : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}
              >
                {city}
              </button>
            ))}
          </div>
        </div>

        {/* ================= SLIDER ================= */}
        <div className="relative">
          <button
            onClick={() => scrollSlider("prev")}
            className="absolute -left-1 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-all duration-300 hover:bg-primary/10 hover:text-primary hover:scale-110 md:left-0"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-left h-4 w-4 md:h-5 md:w-5"><path d="m15 18-6-6 6-6"></path></svg>
          </button>

          {/* <div
            ref={sliderRef}
            className="flex snap-x snap-mandatory gap-3 md:gap-4 overflow-x-auto pb-6"
          >
            {filteredMeetups.length === 0 && (
              <p className="text-slate-500 px-4">
                No meetups found
              </p>
            )}

            {filteredMeetups.map((item, i) => (
              <div
                    key={i}
                    className="group flex-shrink-0 snap-start overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all w-[300px]"
                  >
                    <div className="relative h-[220px] overflow-hidden">
                      <img
                          src={
                            item.image
                              ? `${API_BASE}${item.image}`
                              : `${API_BASE}default.jpg`
                          }
                          alt={item.title}
                          onError={(e) => (e.target.src = `${API_BASE}default.jpg`)}
                          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                        />

                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                      
                      <div class="absolute top-3 right-3 flex gap-2"><div class="rounded-full bg-white/90 px-2.5 py-1 shadow-sm backdrop-blur-sm"><p class="flex items-center gap-1.5 text-xs font-medium text-slate-800"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users h-3 w-3 text-primary"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>{item.spots}</p></div></div>
                      <div class="absolute top-3 left-3"><div class="rounded-full bg-primary/90 px-2.5 py-1 shadow-sm backdrop-blur-sm"><p class="flex items-center gap-1.5 text-xs font-medium text-white"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-calendar h-3 w-3 text-white"><path d="M8 2v4"></path><path d="M16 2v4"></path><rect width="18" height="18" x="3" y="4" rx="2"></rect><path d="M3 10h18"></path></svg>{item.date}</p></div></div>
                      <div class="absolute bottom-0 left-0 right-0 p-4"><div class="mb-2 flex flex-wrap gap-1.5">

                      {(() => {
                          const categories = parseCategories(item.category);

                          return (
                            <>
                              {categories[0] && (
                                <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-white/20 text-white backdrop-blur-sm">
                                  {categories[0]}
                                </span>
                              )}

                              {categories.length > 1 && (
                                <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-white/20 text-white backdrop-blur-sm">
                                  +{categories.length - 1}
                                </span>
                              )}
                            </>
                          );
                        })()}



                  <span class="px-2 py-0.5 rounded-full text-xs font-medium bg-white/20 text-white backdrop-blur-sm">+{item.category_count}</span></div><h3 class="text-lg md:text-xl font-bold text-white mb-1 group-hover:text-primary/90 transition-colors">{item.heading}</h3><div class="flex flex-wrap items-center gap-3 text-xs text-white/90"><div class="flex items-center gap-1"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin h-3 w-3 text-primary"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg><span>{item.city}</span></div><div class="flex items-center gap-1"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock h-3 w-3 text-primary"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg><span>{item.time}</span></div></div></div>

                  
                </div>



                <div className="p-3 bg-white flex justify-between items-center">
                  <div>
                    <p class="text-[10px] text-slate-500">Hosted by</p><p class="text-xs font-semibold text-slate-800">Vikram S.</p>
                  </div>
              <a href={`/MeetupsDtl/${item.id}`}>
                  <button class="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-8 rounded-full bg-primary text-white hover:bg-primary/90 px-3 py-1 text-xs">View Details<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-right ml-1 h-3 w-3"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></button>
              </a>
                </div>
              </div>
            ))}
          </div> */}

          <div
  ref={sliderRef}
  className="flex snap-x snap-mandatory gap-3 md:gap-4 overflow-x-auto pb-6"
>
  {filteredMeetups.length === 0 && (
    <p className="text-slate-500 px-4">No meetups found</p>
  )}

  {filteredMeetups.map((item, i) => (
    <div
      key={i}
      className="group flex-shrink-0 snap-start overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all w-[320px]"
    >
      {/* IMAGE SECTION */}
      <div className="relative h-[220px] overflow-hidden">
        <img
          src={
            item.image
              ? `${API_BASE}${item.image}`
              : `${API_BASE}default.jpg`
          }
          alt={item.heading}
          onError={(e) =>
            (e.currentTarget.src = `${API_BASE}default.jpg`)
          }
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />

        {/* GRADIENT */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />

        {/* TOP RIGHT – SPOTS */}
        <div className="absolute top-3 right-3 flex gap-2">
          <div className="rounded-full bg-white/90 px-2.5 py-1 shadow-sm backdrop-blur-sm">
            <p className="flex items-center gap-1.5 text-xs font-medium text-slate-800">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-3 w-3 text-primary"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
              {item.spots}
            </p>
          </div>
        </div>

        {/* TOP LEFT – DATE */}
        <div className="absolute top-3 left-3">
          <div className="rounded-full bg-primary/90 px-2.5 py-1 shadow-sm backdrop-blur-sm">
            <p className="flex items-center gap-1.5 text-xs font-medium text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-3 w-3 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M8 2v4" />
                <path d="M16 2v4" />
                <rect x="3" y="4" width="18" height="18" rx="2" />
                <path d="M3 10h18" />
              </svg>
              {item.date}
            </p>
          </div>
        </div>

        {/* BOTTOM CONTENT */}
        <div className="absolute bottom-0 left-0 right-0 p-4">
          {/* CATEGORIES */}
          <div className="mb-2 flex flex-wrap gap-1.5">
            {(() => {
              const categories = parseCategories(item.category);
              return (
                <>
                  {categories[0] && (
                    <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-white/20 text-white backdrop-blur-sm">
                      {categories[0]}
                    </span>
                  )}
                  {categories.length > 1 && (
                    <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-white/20 text-white backdrop-blur-sm">
                      +{categories.length - 1}
                    </span>
                  )}
                </>
              );
            })()}
          </div>

          {/* TITLE */}
          <h3 className="text-lg md:text-xl font-bold text-white mb-1 group-hover:text-primary/90 transition-colors">
            {item.heading}
          </h3>

          {/* LOCATION + TIME */}
          <div className="flex flex-wrap items-center gap-3 text-xs text-white/90">
            <div className="flex items-center gap-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-3 w-3 text-primary"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              <span>{item.city}</span>
            </div>

            <div className="flex items-center gap-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-3 w-3 text-primary"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
              <span>{item.time}</span>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <div className="p-3 bg-white flex justify-between items-center">
      {item.local_experts_details && item.local_experts_details.length > 0 && (
        <div>
          <p className="text-[10px] text-slate-500">Hosted by</p>
          <p className="text-xs font-semibold text-slate-800">
            {item.local_experts_details[0].name}
          </p>
        </div>
      )}

        <a href={`/MeetupsDtl/${item.id}`}>
          <button className="inline-flex items-center h-8 rounded-full bg-primary text-white hover:bg-primary/90 px-3 py-1 text-xs">
            View Details
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="ml-1 h-3 w-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M5 12h14" />
              <path d="m12 5 7 7-7 7" />
            </svg>
          </button>
        </a>
      </div>
    </div>
  ))}
</div>


          <button
            onClick={() => scrollSlider("next")}
            className="absolute -right-1 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-all duration-300 hover:bg-primary/10 hover:text-primary hover:scale-110 md:right-0"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right h-4 w-4 md:h-5 md:w-5"><path d="m9 18 6-6-6-6"></path></svg>
          </button>
        </div>
        <div class="mt-8 text-center"><a href="/meetups"><button class="inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 py-2 text-sm md:text-base border-primary/30 bg-transparent text-primary hover:bg-primary/10 px-4">View All Meetups<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right ml-1.5 h-4 w-4 md:h-5 md:w-5"><path d="m9 18 6-6-6-6"></path></svg></button></a></div>
      </div>
    </section>
  );
};

export default UpcomingMeetups;
